import { getPodsFilterState } from 'app/features/teams/messages/table-filters/PodsFilter'
import { getManagerFilterState } from 'app/features/teams/messages/table-filters/PropertyManagerFilter'
import { filtersInitialState } from 'app/pages/teams/rental-references/components/SearchAndFilter/filters.config'
import { getSortFilterState } from 'app/pages/teams/rental-references/components/SearchAndFilter/SortFilter'
import { getStatusFilterState } from 'app/pages/teams/rental-references/components/SearchAndFilter/StatusFilter'
import { LogFetchError } from 'app/shared_components/helpers'
import * as sharedHelpers from 'app/shared_components/helpers'
import { apiBaseUrl } from 'app/shared_components/shared_base_url'

export const getRentalReferencesForAgency = (
  agencyGUID,
  limit = '',
  offset = '',
  filterValues = filtersInitialState,
) => {
  const { search, manager, pods, status, sort } = filterValues

  const managerFilter = getManagerFilterState(manager)
  const podsFilter = getPodsFilterState(pods)
  const statusFilter = getStatusFilterState(status)
  const sortFilter = getSortFilterState(sort)

  let searchParams = new URLSearchParams()
  const url = `${apiBaseUrl}sm/teams/${agencyGUID}/rentalreferences?q=${search}&limit=${limit}&offset=${offset}&sort_dir=${
    sortFilter[0] ?? ''
  }&assignee=${managerFilter[0] ?? ''}&status=${statusFilter[0] ?? ''}`
  podsFilter.forEach((pod) => searchParams.append('pods', pod))

  return fetch(url + `&${searchParams}`, {
    credentials: 'include',
  })
    .catch((error) => LogFetchError(error))
    .then(sharedHelpers.checkStatus)
    .then((result) => ({ ok: true, result }), sharedHelpers.returnAPIError)
}

// Legacy! use one from src/app/services/http/rentalReferences/index.jsx instead
export const getCountForRentalReferencesForAgency = (
  agencyGUID,
  filterValues = {},
) => {
  const {
    managerValue = '',
    statusValue = '',
    dateValue = '',
    searchValue = '',
    retention = 0,
  } = filterValues
  const url = `${apiBaseUrl}sm/teams/${agencyGUID}/rentalreferences/count?q=${searchValue}&sort_dir=${dateValue}&assignee=${managerValue}&status=${statusValue}&retention=${retention}`
  return fetch(url, {
    credentials: 'include',
  })
    .catch((error) => LogFetchError(error))
    .then(sharedHelpers.checkStatus)
    .then((result) => ({ ok: true, result }), sharedHelpers.returnAPIError)
}
